import {
  IEventMap,
  LayoutMode,
  TemplateModel,
  TerminalType,
  VideoState,
} from "../type/index";

/** * SDK version * replace string to really version when build */
export const VERSION = "_BUILDVERSION_";

export const CUSTOM_CODE_PREFIX = "XYSDK:96"; // 错误码前缀

export const SUCCESS_CODE = "XYSDK:969001"; // 成功

export const LOGIN_STATE_MAP = {
  "0": "Logined",
  "1": "Logining",
  "2": "logouting",
  "3": "Logouted",
};

/**
 * 会议连接状态
 */
export const CONNECT_STATE_MAP = {
  "0": "Not_Connect",
  "1": "Connected",
};

/**
 * 呼叫会议状态
 */
export const CALL_STATE_MAP = {
  "0": "Connected",
  "1": "Disconnected",
  "2": "Connecting",
  "3": "Disconnecting",
};

/**
 * Local View ID
 * use this id match local video frame buffer data;
 */
export const LOCAL_VIEW_ID = "LocalPreviewID";

/**
 * 默认的local layout数据
 */
export const DEFAULT_LOCAL = {
  id: "",
  sourceId: "",
  roster: {
    displayName: "",
    isContent: false,
    state: VideoState.Received,
    sourceId: "",
    audioMute: false,
    callUri: "",
    isActiveSpeaker: false,
    videoWidth: 0,
    videoHeight: 0,
    dt: TerminalType.DESKTOP,
  },
  position: {
    width: 0,
    height: 0,
  },
  positionStyle: {
    top: "",
    left: "",
    width: "",
    height: "",
  },
};

/**
 * 默认Make Call方法参数信息
 */
export const DEFAULT_MAKE_CALL_INFO = {
  meetingNumber: "",
  displayName: "",
  meetingPwd: "",
};

export const SDK_CALL_MODE = {
  AudioVideo: 0,
  AudioOnly: 1,
  MonitorMode: 10,
};

export const HTTP_METHOD = {
  GET: 0,
  POST: 1,
  PUT: 2,
  DELETE: 3,
};

export const SDK_FACE_TYPE = {
  Detect: 0,
  EletronicBadge: 2,
};
/**
 * 注册事件名
 */
export const EVENT: IEventMap = {
  // 登录状态
  RTC_EVENT_LOGIN_STATE: "LoginState",
  // 上报网络连接状态
  RTC_EVENT_CONNECT_STATE: "ConnectState",
  // 会议呼叫状态
  // 1: 无效的extId;
  // 2: 网络错误;
  // 3: 服务错误(无法访问服务器)
  // 4: 没有登录
  // 5: 内部状态错误
  // 6: 会议密码错误
  // 7: 无效的会议号
  // 8: 会议异常断开(具体错误细节需要看：SDKCallStateInfo->disconnectReason)
  RTC_EVENT_CALL_STATE: "CallState",
  // 会议室信息 名称/会议类型/会议号
  RTC_CONFERENCE_INFO: "ConferenceInfo",
  // 等候室信息
  RTC_ON_HOLD_INFO: "OnHold",
  // 视频流信息数据事件，通过requestLayout触发获取视频流;
  // 包含source_id数据，通过此值可以调用getVideoFrame方法获取真实的yuv buffer数据用来渲染画面;
  RTC_EVENT_VIDEO_STREAMS: "VideoStreams",
  // 分享content状态
  RTC_EVENT_CONTENT_STATE: "ContentState",
  // 自动布局模式下使用，返回画面布局容器的宽高信息，会跟随屏幕大小变化而重新计算；
  RTC_EVENT_SCREEN_INFO: "ScreenInfo",
  // 账号被踢、过期失效消息，v0.1.5+版本支持
  RTC_EVENT_KICK_OUT: "KickOut",
  // 会议参会信息变化事件，v0.2.0+版本支持
  // participantCount将包含本地Local数据，即现在推送的数据比之前多一个
  RTC_EVENT_CONF_INFO_CHANGED: "ConfInfoChanged",
  // 上报视频流裸数据，暂时存在性能问题，已经废弃
  RTC_EVENT_Video_Frame_Ready: "VideoFrameReady",
  // Local 声音大小回调
  RTC_EVENT_MIC_ENERGY_REPORTED: "MicEnergyReported",
  // 监听错误信息
  RTC_EVENT_SDK_ERROR: "SDKError",
  // 会控消息
  RTC_EVENT_CONF_CONTROL: "ConfControl",
  // 设备变动监听回调，返回变动设备的类型，业务层基于类型重新获取设备列表数据
  // v0.1.5+
  RTC_MEDIA_DEVICE_EVENT: "MediaDeviceEvent",
  // 本地网络状况上报 回调频率根据入会终端期望带宽和 DBA(动态带宽调整)探测带宽的比例计算;
  // 计算的 Level 不同会上报，同时也跟终端网络的稳定性有关
  // 一共4档：1、2、3、4 分别为：差、中、良、优
  RTC_NETWORK_INDICATOR_LEVEL: "NetworkIndicatorLevel",
  // 上报 MicMute 状态
  // 兼容：v0.2.0+
  RTC_EVENT_MIC_MUTED: "MicMuted",
  // 上报video画面状态数据
  RTC_EVENT_VIDEO_STATUS_CHANGED: "VideoStatusChanged",
  // 暂时未对外，邀请通话事件
  RTC_EVENT_CALL_INVITED: "CallInvited",
  // 检测到啸叫(用户可降低声音或关闭麦克风结束啸叫)
  RTC_HOWLING_DETECTED: "HowlingDetected",
  // 字幕消息
  RTC_SUB_TITLE: "SubTitle",
  // 出入会提醒
  RTC_IN_OUT_REMINDER: "InOutReminder",
  // 本地麦克风状态，当会议状态或者操作影响到麦克风状态时，会推送此事件上层更新麦克风状态；
  RTC_EVENT_AUDIO_STATUS_CHANGED: "AudioStatusChanged",
  // 通知上层设备发生变化，通过startSlave注册设备
  RTC_EVENT_EX_DEVICES_CHANGED: "ExDevicesChanged",
  // 从端videoStream事件
  RTC_VIDEO_STREAM_CHANGED_IN_SLAVE: "VIdeoStreamChangedInSlave",
  // force layout
  RTC_EVENT_FORCE_FULL_SCREEN: "ForceFullScreen",
  // 人脸信息
  RTC_AI_FACE_INFO: "AIFaceInfo",
  // 3.8 c++ 移除
  RTC_AI_FACE_RECV: "AIFaceRecv", 
  // Http
  RTC_HTTP_RESPONSE: "HttpResponse",
  // 会控MUTE本地摄像头事件上报
  RTC_MEETING_MUTE_QUERY: "MeetingMuteQuery",
  // 远端录制状态上报
  RTC_RECORD_STATUS_NOTIFICATION: "RecordStatusNotification",
  // 本地录制状态上报
  RTC_RECORD_STATE_CHANGED: "RecordingStateChanged",
  // 自动布局 分页信息
  RTC_PAGE_INFO: "PageInfo",
  // layout布局方式改变
  RTC_TEMPLATE_MODEL_CHANGED: "TemplateModelChanged",
  // 日志上传回调
  LOG_UPLOAD_RESULT: "LogUploadResult",
  // 会控主持人回调
  CONF_HOST_CHANGED: "ConfHostChanged",
  // 会控取消举手回调
  CONF_HAND_UP_CANCELLED: "ConfHandupCancelled",
  // 互动工具回调 签到、答题等
  INTERACTIVE_TOOL_INFO: "InteractiveToolInfo",
  // 签到结果回调
  SUBMIT_SIGNATURE_RESULT: "SubmitSignatureInfosResult",
  // 设备列表
  DEVICE: "Device",
  // 当前勾选设备
  CURRENT_DEVICE: "CurrentDevice",
  // 是否支持同传字幕
  SUPPORT_AI_CAPTION_RESULT: "SupportAiCaptionResult",
  // 字幕内容
  AI_CAPTION_INFO_CHANGED: "AiCaptionInfoChanged",
  // 会控H5链接
  HOST_MEETING_URL: "HostMeetingUrl",
  /** 共享 App 窗口捕获状态 */
  APP_WINDOW_CAPTURE_STATE: "AppWindowCaptureState",
  /** TODO: */
  APP_WINDOW_CAPTURE_STATE_NO_EXTERNAL_SCREEN:
    "AppWindowCaptureState_NoExternalScreen",
  /** 共享 App 窗口显示区域 */
  APP_WINDOW_VISIBLE_AREA: "AppWindowVisibleArea",
  // 主持会议权限
  HOST_AUTHORITY: "HostAuthority",
  // 联席主持人权限
  CO_CHAR_AUTHORITY: "CoChairAuthority",
  // 批注开始
  ANNOTATION_START: "AnnotationStart",
  // 批注停止
  ANNOTATION_STOP: "AnnotationStop",
  // 批注清除
  ANNOTATION_CLEAN: "AnnotationClean",
  // 接收批注线条
  ANNOTATION_RECEIVER_LINE: "AnnotationReceiveLine",
};

/**
 * layout模板模式按布局分类获取
 */
export const TemplateModelRangeMap: {
  [key in LayoutMode]: TemplateModel[];
} = {
  NORMAL: [TemplateModel.SPEAKER, TemplateModel.GALLERY],
  CONTENT: [
    TemplateModel.MULTI_PIC_CONTENT_HIGH_PRIORITY,
    TemplateModel.MULTI_PIC_ACTIVE_HIGH_PRIORITY,
    TemplateModel.TWO_PIC_PIP,
    TemplateModel.CONTENT_ONLY,
    TemplateModel.TWO_PIC_SYMMETRIC,
  ],
};

/**
 * 外接屏渲染模式默认配置参数
 */
export const DEFAULT_MASTER_CONFIG = {
  authTimeout: 6000,
  localIP: "127.0.0.1",
  keepAliveTimeout: 6000,
  keepAliveInterval: 2000,
  name: "masterThread",
  readInterval: 40,
  maxDataLength: 10240,
  serverPort: 6006,
  serverIP: "127.0.0.1",
  moduleType: 0,
  connType: 1,
};

export enum LocalPreviewResolution {
  init = 10,
  low180P = 1,
  normal360P = 2,
  hd720P = 3,
  highHd1080P = 4,
}

export const MAX_SIZE = 9;

export const DEFAULT_PAGE_INFO = {
  currentPage: 0,
  maxSize: MAX_SIZE,
  totalPage: 0,
};

export const DEFAULT_CONF_INFO = {
  contentPartCount: 0,
  participantCount: 0,
  chairManUrl: "",
  visibleEpCount: 0,
};

export const ENUM_COPY_WRITING = {
  1: "dialogTitle",
  2: "dialogContent",
  3: "dialogSubContent",
  4: "dialogLabel",
  5: "notifyContent",
  6: "notifyLabel",
  7: "notifyContent",
  8: "dialogContent",
  9: "dialogSubContent",
  10: "dialogLabel",
};

/**
 * 支持的虚拟背景图片文件类型
 */
export const ACCEPT_VIRTUAL_IMG_TYPE = [
  '.jpg',
  '.jpeg',
  '.png',
];

/**
 * 数据统计: electron platform转sysType
 */
export const platformTagMap = {
  darwin: 'macOS',
  win32: 'Windows',
  // linux: 'Linux',
}
